/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum PostgresqlContext {
  Internal = 'internal',
  Postmaster = 'postmaster',
  Sighup = 'sighup',
  SuperuserBackend = 'superuser-backend',
  Backend = 'backend',
  Superuser = 'superuser',
  User = 'user',
}
